<div class="container walletConnectDialog">
    <div class="row">
        <div class="col-12">
            <nb-card>
                <nb-card-header>
                    <h3>Choose a wallet</h3>
                    <!-- <button nbButton (click)="close()">a</button> -->
                </nb-card-header>


                <nb-card-body>

                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex">
                                <div class="col-6 d-flex justify-content-center">
                                    <img
                                    class=" walletConnectIcon justify-content-center  ml-2 mb-1"
                                    src="../../assets/images/walletconnect-logo.svg"
                                />
                                </div>
                                <div class="col-6 d-flex justify-content-center ">
                                <img
                                    class=" walletConnectIcon justify-content-center  ml-2 mb-3"
                                    src="../../assets/images/metamask-2728406-2261817.png"
                                />
                            </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6 col-xl-8">
                            <div class="d-flex">
                                <button
                                    nbButton
                                    status="basic"
                                    class="btn mr-2"
                                    (click)="connectWalletConnect()"
                                >
                                    WalletConnect
                                </button>
                                <button
                                nbButton
                                status="basic"
                                class="btn  ml-2"
                                (click)="connectMetamask()"
                            >
                                Metamask
                            </button>
                            </div>
                        </div>
                    </div>
                    <br />

                </nb-card-body>
            </nb-card>
        </div>
    </div>
</div>
